import {type CardEnum, type CardStateOrdered} from '@colonist/game-states'
import {BaseCardValidator} from './BaseCardValidator.ts'

export class CardValidatorOrdered extends BaseCardValidator<CardStateOrdered> {
    get cards(): CardEnum[] {
        const clonedCards: CardEnum[] = []
        for(const card of this.state.cards) {
            clonedCards.push(card)
        }
        return clonedCards
    }
}
